import { useEffect, useState } from "react";
import "./Order.css"
function Order() {
  return (
    <div className="order">
      <h1>作曲依頼について</h1>
      <p>作曲・編曲についてです。</p>
      <div className="instruments">
        <h2>使用機材</h2>
        <table>
          <tr>
            <th>Audio Interface</th>
            <td>Presonus Studio 24c</td>
          </tr>
          <tr>
            <th>DAW</th>
            <td>Studio One 6 Professional</td>
          </tr>
          <tr>
            <th>Headphone</th>
            <td>AKG K240 Studio</td>
          </tr>
            <tr>
            <th>Speaker</th>
            <td>Presonus Eris 3.5</td>
          </tr>
          <tr>
            <th>MIDI-Key</th>
            <td>M-AUDIO Key Station 88</td>
          </tr>
          <tr>
            <th>Guitar</th>
            <td>Gibson Les Paul Studio / Squire Telecaster</td>
          </tr>
          <tr>
            <th>Amp Simulator</th>
            <td>BIAS FX2/Amplitube 5</td>
          </tr>
          <tr>
            <th>Acoustic Piano</th>
            <td>Pianovarse</td>
          </tr>
          <tr>
            <th>Acoustic Drum</th>
            <td>MODO DRUM 1.5/BFD Player</td>
          </tr>
          <tr>
            <th>Bass</th>
            <td>MODO BASS 2/Junk Legend Bass</td>
          </tr>
           <tr>
            <th>Vocal</th>
            <td>Synthesizer V2 重音テト/Mai/Liam</td>
          </tr>
          
        </table>
      </div>
      <div className="price">
        <h2>料金</h2>
0円から(無料)承っています。依頼は<a href="https://feat.kurogo.studio/6451?portfolio_job_name=Composer">こちら</a>か    <a href="mailto:bugslove.music@gmail.com">bugslove.music@gmail.com</a>にて。
        </div>
    </div>
  )
}

export default Order;